import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataPermisosService {
  private listaReportesPermiso: Permisos[] = [
    {
      nombre: 'reporte-soma',
      imprimir: false,
      descargar: true,
      filtros: true
    },
    {
      nombre: 'analisis-habilidad',
      imprimir: true,
      descargar: false,
      filtros: false
    },
    {
      nombre: 'reporte-cenpresabil',
      imprimir: true,
      descargar: false,
      filtros: false
    },
    {
      nombre: 'historia-cenpresabil',
      imprimir: true,
      descargar: false,
      filtros: false
    }, {
      nombre: 'reporte-comfenalco',
      imprimir: false,
      descargar: true,
      filtros: true
    }
  ];

  constructor() {}

  public getPermisos(nombrePath: string) {
    let objetoResult: any = {
      imprimir: false,
      descargar: false,
      filtros: false
    };

    for (let i = 0; i < this.listaReportesPermiso.length; i++) {
      if ( this.listaReportesPermiso[i].nombre === nombrePath ) {
        objetoResult = {
          imprimir: this.listaReportesPermiso[i].imprimir,
          descargar: this.listaReportesPermiso[i].descargar,
          filtros: this.listaReportesPermiso[i].filtros
        };
      }
    }

    return objetoResult;

  }
}

interface Permisos {
  nombre: string;
  imprimir: boolean;
  descargar: boolean;
  filtros: boolean;
}
